import { PostFeatures } from "./types";

import * as S from "./styles";

const Features = (props: PostFeatures) => {
  return (
    <S.Features>
      <S.Title>{props.title}</S.Title>
      <S.Grid>
        {props.itens?.map((item, i) => (
          <S.Item key={i}>
            {props.status === "negative" && (
              <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="15" cy="15" r="15" fill="#E11D48" />
                <path
                  d="M15.5717 15L20.9608 8.28129C21.0512 8.16963 20.9752 8 20.8356 8H19.1973C19.1008 8 19.0084 8.04509 18.9448 8.12239L14.5 13.6644L10.0552 8.12239C9.99364 8.04509 9.90125 8 9.80271 8H8.16441C8.0248 8 7.94884 8.16963 8.03917 8.28129L13.4283 15L8.03917 21.7187C8.01894 21.7436 8.00595 21.774 8.00177 21.8064C7.99758 21.8388 8.00236 21.8717 8.01555 21.9014C8.02873 21.931 8.04977 21.956 8.07615 21.9735C8.10254 21.991 8.13317 22.0002 8.16441 22H9.80271C9.8992 22 9.99159 21.9549 10.0552 21.8776L14.5 16.3356L18.9448 21.8776C19.0064 21.9549 19.0987 22 19.1973 22H20.8356C20.9752 22 21.0512 21.8304 20.9608 21.7187L15.5717 15Z"
                  fill="white"
                />
              </svg>
            )}
            {props.status === "positive" && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
              >
                <circle cx="15" cy="15" r="15" fill="#10B981" />
                <path
                  d="M21.4 7L11.48 17.9091L8.6 15.7277H7L11.48 23L23 7H21.4Z"
                  fill="white"
                />
              </svg>
            )}
            <p>{item.title}</p>
          </S.Item>
        ))}
      </S.Grid>
    </S.Features>
  );
};

export default Features;
